import { useTheme } from 'next-themes';
import { Button } from '../tailgrids/core/button.js';
import { MoonIcon, SunIcon } from './shell-icons.js';

/**
 * Header light/dark switch. The same theme is set from Settings → Preferences.
 * Template example: NextAdmin `components/common/header/theme-toggle.tsx`.
 */
export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <Button
      iconOnly
      appearance="outline"
      onPress={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      className="size-10 rounded-lg border border-card-border bg-card-background text-icon-primary shadow-xs outline-none focus-visible:border-input-primary-focus-border focus-visible:ring-4 focus-visible:ring-input-primary-focus-border/20 [&>svg]:size-auto"
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </Button>
  );
}
